




























import Vue from 'vue';
import Currency from '@/components/Currency.vue';
import Comprobante from '@/models/Comprobante';
import FormaCobro from '@/models/FormaCobro';
import Campo from '@/models/Campo';

import Entidad from '@/models/Entidad.vue';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
		};
	},
	watch: {},

	computed: {
		formObservaciones() {
			return this.$store.state.recibos.formObservaciones;
		},
		parametros() {
			return this.$store.state.config.parametros;
		},
	},
	filters: {},
	methods: {
		isDisabled() {
			return this.parametros && this.parametros.recibos && this.parametros.recibos.modifica_fecha ? false : true;
		},
	},
	mounted() {
		//this.$store.dispatch('callTableRecibos');
	},
};
